import { httpGET, httpPOST, httpPUT } from './http'

const API_URL = 'https://assetanalysis-socketservices-mo7niavhjq-de.a.run.app/v1/activeEngines'
const BASE_URL = 'https://assetanalysis.techolution.com/api'

export const getActiveEngines = (filter = { where: { engineName: 'AI' } }) => {
  return httpGET(`${API_URL}?filter=${JSON.stringify(filter)}`)
}

export const setPrimaryEngine = (data = {}) => {
  return httpPUT(`${API_URL}/set-primary`, data)
}

export const setActiveModel = (data = {}) => {
  return httpPUT(`${API_URL}/set-active`, data)
}

export const getMetricsData = ({ dates }, chartName) => {
  if (dates.length) {
    dates = dates.map(date => {
      return date.replace(/-/g, '/')
    })
    return httpGET(`${BASE_URL}/graph-service/graph/performance?modelName=${chartName}&startDate=${dates[0]}&endDate=${dates[1]}`)
  } else {
    return httpGET(`${BASE_URL}/graph-service/graph/performance?modelName=${chartName}`)
  }
}

export const deployAimodel = (model) => {
  return httpPOST(`${BASE_URL}/feedback-service/ai-model/deploy`, model)
}

export const getAccuracy = () => {
  return httpGET(`${BASE_URL}/graph-service/graph/all/accuracy`)
}
